module.exports = "<ngb-alert *ngIf=\"successMessage\" type=\"success\" (close)=\"successMessage = null\">{{ successMessage }}</ngb-alert>\n<div class=\"content-splash\">\n  <img src=\"assets/logo.jpg\" alt=\"logo app intrapro\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/splash/splash.component.html
// module id = ./src/app/pages/splash/splash.component.html
// module chunks = main